<template>
  <div
    id="newsletterSignup"
    v-if="display"
  >
    <h3>{{ $t('donationForm.details.newsletter.title') }}</h3>
    <div>
      <small>{{ $t('donationForm.details.newsletter.text') }}</small>
    </div>
    <CheckBox
      :label="$t('donationForm.details.newsletter.label')"
      v-model="newsletter"
    />
    <div
      id="trackingConsent"
      v-if="trackingConsentAsked"
    >
      <CheckBox
        :label="$t('donationForm.details.trackingConsent.label')"
        v-model="trackingConsent"
      />
    </div>
  </div>
</template>

<script>
import CheckBox from '@/components/form/CheckBox'
import { useDonationStore } from '@/stores/donation'

export default {
  name: 'NewsletterSignup',
  setup () {
    const donationStore = useDonationStore()
    return { donationStore }
  },
  components: { CheckBox },
  computed: {
    newsletter: {
      get () { return this.donationStore.newsletter },
      set (newValue) {
        this.donationStore.setNewsletter(newValue)
      }
    },
    trackingConsent: {
      get () { return this.donationStore.trackingConsent },
      set (newValue) {
        this.donationStore.setTrackingConsent(newValue)
      }
    },
    display () { return this.$l10n.currentLocation.formFields.newsletter.show },
    trackingConsentOffered () {
      return Boolean(this.$l10n.currentLocation.formFields.trackingConsent?.show)
    },
    trackingConsentAsked () { return this.trackingConsentOffered && this.newsletter }
  },
  watch: {
    // The moment the question is put, an untouched box is a refusal, not "never
    // asked". Withdrawing the newsletter opt-in withdraws the question with it.
    newsletter (optedIn) {
      if (optedIn) {
        if (this.trackingConsentOffered) this.donationStore.setTrackingConsent(false)
      } else {
        this.donationStore.setTrackingConsent(null)
      }
    }
  },
  mounted () {
    this.donationStore.setNewsletter(this.$l10n.currentLocation.formFields.newsletter.prechecked)
  }
}
</script>

<style lang="scss" scoped>
  h3 {
    color: white;
    font-family: var(--titles-font-family-medium);
    margin-bottom: 0.5rem;
  }

  .form-check {
    padding-top: 0.5em;
  }
</style>
